import api from '@/services/api'


export default {
    fetchAdditionalCosts(params) {
        return api.get(`additional_costs/`, {params})
            .then(response => response.data)
    },
    postAdditionalCost(additional_cost) {
        return api.post(`additional_costs/`, additional_cost)
            .then(response => response.data)
    },
    bulkPostAdditionalCosts(data) {
        return api.post(`additional_costs/bulk_create/`, data)
            .then(response => response.data)
    },
    editAdditionalCost(additional_cost) {
        return api.put(`additional_costs/${additional_cost.id}/`, additional_cost)
            .then(response => response.data)
    },
    getAdditionalCost(params) {
        return api.get(`additional_costs/${params.id}/`)
            .then(response => response.data)
    },
    deleteAdditionalCost(id) {
        return api.delete(`additional_costs/${id}/`)
            .then(response => response.data)
    }
}